import OrgAPI from '@/apis/business/account/organization-api.js'

export default {
  namespaced: true,
  state: {
    Account: { }
  },

  getters: {},

  actions: {
    /**
     * @description Lấy Organization theo locationID
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getByLocationID (context, params) {
      return OrgAPI.getAsync(`location/${params.locationID || 'Organization'}`)
    }
  }
}
